import {
    Building2,
    Coffee,
    Fuel,
    Gem,
    Pill,
    ShoppingBasket,
    Store,
    Wine,
} from "lucide-react";
import { Reveal } from "./Reveal";

const AUDIENCES = [
    { icon: Store, label: "Convenience stores", testid: "retail-item-convenience" },
    { icon: Fuel, label: "Gas stations", testid: "retail-item-gas" },
    { icon: ShoppingBasket, label: "Grocery stores", testid: "retail-item-grocery" },
    { icon: Wine, label: "Liquor stores", testid: "retail-item-liquor" },
    { icon: Coffee, label: "Restaurants and cafés", testid: "retail-item-restaurants" },
    { icon: Pill, label: "Pharmacies", testid: "retail-item-pharmacies" },
    { icon: Gem, label: "Specialty retailers", testid: "retail-item-specialty" },
    {
        icon: Building2,
        label: "Multi-location retail businesses",
        testid: "retail-item-multi-location",
    },
];

export const RetailSection = () => (
    <section
        id="retail"
        className="bg-[#eefbf7] py-20 lg:py-28"
        data-testid="built-for-retail-section"
    >
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <Reveal className="mx-auto mb-14 max-w-2xl text-center sm:mb-16">
                <p className="mb-3 text-xs font-semibold uppercase tracking-[0.22em] text-teal-700">
                    Built for Retail
                </p>
                <h2 className="font-display text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                    Professional Advertising for Every Store
                </h2>
                <p className="mt-4 text-base text-slate-500 sm:text-lg">
                    If you have a screen and something to sell, Scan2Ad fits right in.
                </p>
            </Reveal>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 sm:gap-5 lg:grid-cols-4">
                {AUDIENCES.map((item, i) => (
                    <Reveal key={item.label} delay={i % 4} className="h-full">
                        <div
                            data-testid={item.testid}
                            className="group flex h-full items-center gap-4 rounded-2xl border border-teal-900/5 bg-white px-6 py-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:border-teal-200 hover:shadow-xl hover:shadow-teal-900/10"
                        >
                            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-teal-600/10 text-teal-700 ring-1 ring-teal-600/15 transition-all duration-300 group-hover:bg-teal-600 group-hover:text-white">
                                <item.icon className="h-6 w-6" />
                            </span>
                            <span className="font-display text-base font-semibold leading-snug text-slate-800">
                                {item.label}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
